export const imageFields = `
  id
  altText
  width
  height
  url: url(transform: { maxWidth: $imgWidth, maxHeight: $imgHeight })
`;

export const largeImageFields = `
  id
  altText
  width
  height
  url: url(transform: { maxWidth: 800, maxHeight: 800 })
`;

export const videoFields = `
  url
  width
  height
  format
  mimeType`;

export const cartFields = `{
  id
  createdAt
  updatedAt
  checkoutUrl
  lines(first: 99) {
    edges {
      node {
        id
        quantity
        merchandise {
          ... on ProductVariant {
            id
            title
            product {
              id
              title
            }
            image {
              src
            }
            media: metafield(namespace: "custom", key: "variant_images") {
              value
              type
              references(first: 1) {
                edges {
                  node {
                    ... on MediaImage {
                      id
                      mediaContentType
                      previewImage {
                        ${imageFields}
                      }
                    }
                  }
                }
              }
            }
            price {
              amount
              currencyCode
            }
          }
        }
      }
    }
  }
  attributes {
    key
    value
  }
  # The estimated total cost of all merchandise that the customer will pay at checkout.
  cost {
    totalAmount {
      amount
      currencyCode
    }
    # The estimated amount, before taxes and discounts, for the customer to pay at checkout.
    subtotalAmount {
      amount
      currencyCode
    }
    # The estimated tax amount for the customer to pay at checkout.
    totalTaxAmount {
      amount
      currencyCode
    }
    # The estimated duty amount for the customer to pay at checkout.
    totalDutyAmount {
      amount
      currencyCode
    }
  }
}`;

export const productFields = `
  id
  handle
  title
  label: metafield(namespace: "custom", key: "3d_label") {
    value
  }
  brand: metafield(namespace: "custom", key: "brand") {
    value
  }
  alternativeVariantName: metafield(namespace: "custom", key: "alternative_variant_1") {
    value
  }
  alternativeVariantId: metafield(namespace: "custom", key: "alternative_variant_1_product") {
    reference {
      ... on Product {
        shopifyId: id
        handle
      }
    }
  }
  alternativeVariantImage: metafield(namespace: "custom", key: "alternative_variant_1_image") {
    reference {
      ... on MediaImage {
        id
        image {
          url
        }
      }
    }
  }
  media(first: 99) {
    edges {
      node {
        id
        mediaContentType
        previewImage {
          ${largeImageFields}
        }
        ... on Video {
          sources {
            ${videoFields}
          }
        }
      }
    }
  }
  featuredImage {
    ${largeImageFields}
  }
  priceRange {
    minVariantPrice {
      amount
      currencyCode
    }
    maxVariantPrice {
      amount
      currencyCode
    }
  }
  description
  descriptionHtml
  availableForSale
  vendor
  options {
    id
    name
    values
  }
`;

export const influencerFields = `
  id
  handle
  title
  open: metafield(namespace: "custom", key: "open") {
    value
  }
  highlight: metafield(namespace: "custom", key: "is_highlight") {
    value
  }
  color: metafield(namespace: "custom", key: "color") {
    value
  }
  subline: metafield(namespace: "custom", key: "subline") {
    value
  }
  tiktok: metafield(namespace: "social", key: "tiktok") {
    value
  }
  youtube: metafield(namespace: "social", key: "youtube") {
    value
  }
  snapchat: metafield(namespace: "social", key: "snapchat") {
    value
  }
  instagram: metafield(namespace: "social", key: "instagram") {
    value
  }
  backdrop_image: metafield(namespace: "custom", key: "backdrop_image") {
    value
    type
    reference {
      ... on MediaImage {
        id
        mediaContentType
        previewImage {
          ${largeImageFields}
        }
      }
    }
  }
  description
  handle
  image {
    ${imageFields}
  }
`;

export const variantFields = `
  id
  title
  availableForSale
  currentlyNotInStock
  quantityAvailable
  price {
    amount
    currencyCode
  }
  compareAtPrice {
    amount
    currencyCode
  }
  media: metafield(namespace: "custom", key: "variant_images") {
    value
    type
    references(first: 99) {
      edges {
        node {
          ... on MediaImage {
            id
            mediaContentType
            previewImage {
              ${imageFields}
            }
          }
          ... on Video {
            id
          }
        }
      }
    }
  }
  linkedProduct: metafield(namespace: "custom", key: "linked_product") {
    value
    type
    reference {
      ... on Product {
        ${productFields}
      }
    }
  }
`;

export default {
  cartFields,
  imageFields,
  productFields,
  influencerFields,
  variantFields
};